import {Component, inject} from '@angular/core';
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {MaterialGridViewDto, MaterialStatus, StorageType} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {CommonModule} from "@angular/common";
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective
} from "devextreme-angular";
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {Router, RouterLink} from "@angular/router";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import {CapitalCasePipe} from "../../../pipes/capital-case.pipe";

@Component({
    selector: 'app-materials',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxTemplateDirective,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSearchPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxFormComponent,
        FilterPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxoScrollingComponent,
        CapitalCasePipe,
        RouterLink,
    ],
    templateUrl: './materials.component.html',
    styleUrl: './materials.component.scss',
})
export class MaterialsComponent extends GridPageComponent<MaterialGridViewDto> {
    private router = inject(Router);

    constructor() {
        super();
        this.init(MaterialGridViewDto);
    }

    dataSource = this.dataSources.materials();

    materialStatusOptions = EnumUtils.getEnumOptions(MaterialStatus);
    binTypeOptions = EnumUtils.getEnumOptions(StorageType);

    protected override exportName: string = "Materials";

    protected override filterConfig: FilterConfig[] = [
        {field: 'number', op: 'contains'},
        {field: 'description', op: 'contains'},
        {field: 'business', op: 'contains'},
        {field: 'status', op: '='},
        {field: 'storageType', op: '='},
        {field: 'actualStorageType', op: '='},
        {field: 'clientTotShelfLife', op: '>='},
        {field: 'grossWeight', op: '>='},
        {field: 'netWeight', op: '>='},
        {field: 'weightType', op: 'contains'},
        {field: 'unit', op: 'contains'},
        {field: 'salesUnit', op: 'contains'},
        {field: 'eachesPerSalesUnit', op: '>='},
        {field: 'piecesPerPallet', op: '>='},
        {field: 'casesPerLayer', op: '>='},
        {field: 'casesPerPallet', op: '>='},
        {field: 'layersPerPallet', op: '>='},
        {field: 'stackingFactor', op: '>='},
        {field: 'category', op: 'contains'},
        {field: 'categoryDescription', op: 'contains'},
        {field: 'hierarchyDescription', op: 'contains'},
        {field: 'nationalPrice', op: '>='},
        {field: 'corporateBrand', op: 'contains'},
        {field: 'corporateBrandDescription', op: 'contains'},
        {field: 'rangeBrand', op: 'contains'},
        {field: 'rangeBrandDescription', op: 'contains'},
        {field: 'materialGroup', op: 'contains'},
        {field: 'materialGroupDescription', op: 'contains'},
        {field: 'nestecProductCategoryName', op: 'contains'},
        {field: 'originDescription', op: 'contains'},
        {field: 'created', op: '>='}
    ];

    override async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        const {data} = e;
        await this.router.navigate([`/inventory/materials/details/${data.number}`]);
    }

    protected getStatusBadgeClass(status: MaterialStatus): string {
        return EnumUtils.getMaterialStatusBadgeClass(status);
    }
}
